import {useState} from "react";
import i18n from "../../../i18n/i18n";

const t = (k: string, o?: Record<string, unknown>) => i18n.t(`filters.${k}`, {ns: 'sit', ...o});

/**
 * The chip status of a multi-select: "Any", the one selected label, or "n selected". In Excluding mode `labels` are
 * the excluded options, so n is what stays checked of the `total` options.
 */
export const sitFilterStatus = (labels: string[], excluding = false, total = 0): string => {
    if (labels.length === 0) return t('any');
    if (excluding) return t('selected', {count: Math.max(0, total - labels.length)});
    return labels.length === 1 ? labels[0] : t('selected', {count: labels.length});
};

/** The draft's `excluded` list with `key` in or out of "Excluding" mode. */
export const withExcluded = (excluded: string[], key: string, excluding: boolean): string[] =>
    excluding ? [...excluded.filter(k => k !== key), key] : excluded.filter(k => k !== key);

/**
 * The filters being edited: changes stay in the draft until Apply. The draft follows the applied filters whenever
 * those change (after Apply or Clear all).
 */
export function useSitFilterDraft<T>(applied: T): [T, (change: Partial<T>) => void, boolean] {
    const key = JSON.stringify(applied);
    // The draft belongs to the applied filters it started from; once those change it starts over.
    const [state, setState] = useState<{key: string; draft: T}>({key, draft: applied});
    if (state.key !== key) setState({key, draft: applied});
    const draft = state.key === key ? state.draft : applied;
    return [draft, change => setState({key, draft: {...draft, ...change}}), JSON.stringify(draft) !== key];
}
